import React, { useState } from "react";
import "./Slideshow.css";

const Slideshow = ({ images = []}) => {
  const [index, setIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);

  if (images.length === 0) return null;


  // function to go next and back
  const goNext = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const goBack = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const isVideo = (src) => {
    return src.endsWith(".mp4") || src.endsWith(".webm") || src.endsWith(".ogg");
  };

  return (
    // main wrapper, expands class based on toggle state

    <div className={`slideshow-wrapper ${expanded ? "expanded" : ""}`}>
      {/* button for previous img */}
      <button className="slideshow-btn left" onClick={goBack}>Back</button>

      
      <div 
        className={`slideshow-container ${expanded ? "expanded" : ""}`}
        onClick={() => setExpanded(!expanded)}
      >
        {isVideo(images[index]) ? (
          //if video is being rendered play video 
          <video src={images[index]} controls className="slideshow-image" />
        ) : (
          //if not then show image
          <img
            src={images[index]}
            alt={`Slide ${index + 1}`}
            className="slideshow-image"
          />
        )}
      </div>
      {/* button for next image */}  
      <button className="slideshow-btn right" onClick={goNext}>Next</button>

      {/* dot slider navigation */}
      <div className="slideshow-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${index === i ? "active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </div>

    
  );
};

export default Slideshow